export function createTicketSingleFlight<T>() {
  const flights = new Map<string, Promise<T>>()

  return async (ticket: string, workflow: () => Promise<T>) => {
    const activeFlight = flights.get(ticket)
    if (activeFlight) return activeFlight

    const flight = workflow()
    flights.set(ticket, flight)
    try {
      return await flight
    } finally {
      if (flights.get(ticket) === flight) flights.delete(ticket)
    }
  }
}
